function ensureArray(value) {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
}

const UUID_PATTERN =
  /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

function isUuid(value) {
  return typeof value === 'string' && UUID_PATTERN.test(value.trim());
}

export function formatLocationLabel(location) {
  if (!location) {
    return 'Location';
  }

  const candidates = [
    location.boxName,
    location.name,
    location.locationName,
    location.box_name,
    location.typeName,
    location.externalId,
    location.external_id,
  ].filter((value) => value != null && String(value).trim() !== '');

  let label = candidates.find((value) => !isUuid(String(value)));

  if (!label) {
    const raw =
      location.boxName ||
      location.name ||
      location.boxId ||
      location.id ||
      'Location';
    if (isUuid(String(raw))) {
      return `Location ${String(raw).substring(0, 8)}...`;
    }
    return String(raw);
  }

  label = String(label);
  const boxPrefixMatch = label.match(/^Box\s+(.+)$/i);
  if (boxPrefixMatch && isUuid(boxPrefixMatch[1])) {
    return `Location ${boxPrefixMatch[1].substring(0, 8)}...`;
  }

  return label;
}

export function buildAccountOptions(uiAccounts) {
  const base = ensureArray(uiAccounts).map((account) => {
    const raw =
      (account && (account.accountId || account.id || account.name)) || 'account';
    const label =
      (account && account.name) ||
      (account && account.displayName) ||
      (account && account.accountName) ||
      raw;
    return {
      value: String(raw),
      label,
    };
  });
  return [{ value: 'all', label: 'All accounts' }, ...base];
}

export function buildLocationDirectoryOptions(uiLocations, accountId = 'all') {
  let locations = ensureArray(uiLocations);
  if (accountId && accountId !== 'all') {
    locations = locations.filter(
      (location) => String(location.accountId) === String(accountId)
    );
  }
  return locations.map((location) => {
    const raw =
      (location && (location.boxId || location.id || location.boxName)) || 'location';
    return {
      value: String(raw),
      label: formatLocationLabel(location),
      accountId: String(location.accountId || ''),
    };
  });
}

export function applyBillingDirectory(response, { setAccountOptions, setAllLocationOptions }) {
  if (!response) return;

  if (Array.isArray(response.uiAccounts) && response.uiAccounts.length) {
    setAccountOptions(buildAccountOptions(response.uiAccounts));
  }

  if (Array.isArray(response.uiLocations)) {
    setAllLocationOptions(buildLocationDirectoryOptions(response.uiLocations));
  }
}



// WEBPACK FOOTER //
// ./src/components/billing/billingDirectoryUtils.js